var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"not-found"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"not-found__wrap"},[_c('p',[_vm._v(" 403 ")]),_c('span',[_vm._v(" Недостаточно прав ")])])])])
}]

export { render, staticRenderFns }